module.exports = __webpack_public_path__ + "media/images/application/icons/arrow-select-language-red-b25a270ad4c6eb23e916d7ca3db49193.svg";